import { StatTableCellProps } from "components/StatsTable/StatTableColumn";
import { StatTableTimeColumn } from "./TimeColumn";
import { convertMsToTimeString } from "TimeHelper";
import { StatCell, StatBreakdown } from "../styles";
import { RaceTime } from "./styles";

interface Props<T> extends StatTableCellProps<T, StatTableTimeColumn<T>> {}

export function StatTableTimeCell<T>({
  stats,
  column,
  columnIdx,
  frozenOffset,
}: Props<T>) {
  const time = column.timeGetter(stats);
  const dnfAdjusted = !!column.dnfAdjustedGetter
    ? column.dnfAdjustedGetter(stats)
    : undefined;
  // const driverIds = !!column.driverIdsGetter
  //   ? column.driverIdsGetter(stats)
  //   : [];
  const subText = !!column.subTextGetter
    ? column.subTextGetter(stats)
    : undefined;

  return (
    <StatCell
      key={`${columnIdx} time ${time ?? "-1"}`}
      highlight={column.highlight}
      frozenWidth={column.frozenWidth}
      frozenOffset={frozenOffset}
      border={column.border}
    >
      <RaceTime dnfAdjusted={dnfAdjusted ?? false}>
        {time !== undefined ? convertMsToTimeString(Math.round(time)) : "-"}
      </RaceTime>
      <br />
      {/* <DriverNames driverIds={driverIds} /> */}
      <StatBreakdown>{subText}</StatBreakdown>
    </StatCell>
  );
}

interface DriverNamesProps {
  driverIds: string[];
}

// const DriverNames = ({ driverIds }: DriverNamesProps) => {
//   const driverNames = useAppSelector((state) =>
//     nonUndefined(driverIds.map((id) => selectDriverNickname(state, id)))
//   );

//   return <DriverNameSpan>{driverNames.join(",\n")}</DriverNameSpan>;
// };
